import React from "react";

import { DeletePopUp } from "../PopUp";
import { CORRECTION_DELETE_COPY, correctionDeleteDetailsOf } from "./constants";
import { CorrectionDeletePopUpProps } from "./types";

export const CorrectionDeletePopUp: React.FC<CorrectionDeletePopUpProps> = ({
  correctionDelete: {
    pendingCorrection,
    deleteError,
    isDeleting,
    closeDelete,
    confirmDelete,
  },
}) => {
  if (!pendingCorrection) {
    return null;
  }

  return (
    <DeletePopUp
      isOpen
      setIsOpen={closeDelete}
      title={CORRECTION_DELETE_COPY.title}
      text={CORRECTION_DELETE_COPY.text}
      details={correctionDeleteDetailsOf(pendingCorrection)}
      confirmLabel="Delete"
      isLoading={isDeleting}
      errorMessage={deleteError}
      handleOnDelete={confirmDelete}
    />
  );
};
